import { FormControl, FormGroup } from '@angular/forms';
import { DefaultSelectionValue, FilterInputType, InputProps } from '@miq/shared-models';

/**
 * L2-S5: the pure half of `@shared/components/filters-bar/simple-form-group.service`.
 *
 * `SimpleFormGroupService` is an HTTP service (it extends `HttpMethods` and also exposes
 * `getGeoMarkets`), but `makeGroup` never touches `this` — it is a pure map from `InputProps[]` to
 * a reactive-forms control map. `TreeDataRowComponent` injected the whole service only to call it,
 * which meant the component could not move into this library without dragging an HTTP service with
 * it. Extracting the function keeps ONE implementation: the host service now delegates here.
 *
 * Behaviour is byte-for-byte the original: `Range` inputs become a `{ from, to }` FormGroup seeded
 * from `value.from` / `value.to` (null when absent), everything else becomes a FormControl seeded
 * with `value || ''` and the caller's `controlOptions`.
 */
export function makeSimpleFormGroup<T = DefaultSelectionValue>(
  inputProps: InputProps<T>[]
): { [fcName: string]: FormControl | FormGroup } {
  return inputProps.reduce(
    (acc, prop) => ({
      ...acc,
      [prop.field]:
        prop.type === FilterInputType.Range
          ? new FormGroup({
              from: new FormControl(prop.value?.['from'] || null),
              to: new FormControl(prop.value?.['to'] || null),
            })
          : new FormControl(prop.value || '', prop.controlOptions || {}),
    }),
    {}
  );
}
